import { Component, OnInit } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router, ActivatedRoute } from '@angular/router';
import { DocumentReviewsService } from '../../../service/crud-entity-services/document-reviews.service';
import { DomSanitizer } from '@angular/platform-browser';
import { NewCriticalDateComponent } from '../../../create-new/new-critical-date/new-critical-date.component';
import { ToastMessageDialog } from '../../../toolbar-components/toolbar-utilities/view-utilities';

import { MatDialog } from '@angular/material/dialog';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatDividerModule } from '@angular/material/divider';

import * as importantDateColumns from '../../../shared/entity-columns/important-dates-columns';

import { DocumentReview } from '../../../objects/doc-review';
import { EntityRecord } from '../../../objects/entity-record';

import { Attachment } from '../../../objects/attachment';
import { ViewEntity } from '../../../objects/view-entity';

let _ = require('lodash');



@Component({
    selector: 'app-document-review-form',
    templateUrl: './document-review-form.component.html',
    styleUrls: ['./document-review-form.component.css'],
    standalone: true,
    imports: [
      MatSidenavModule,
      MatDividerModule,
    ]
  })
export class DocumentReviewFormComponent extends ViewEntity implements OnInit {

  partyFriendlyName = null;
  legalEntitiesFriendlyNames = [];
  siteFriendlyNames = [];

  tabSelected = null;
  reviewsTabOnScreen = false;
  documentVersionsTabOnScreen = false;
  detailsTabOnScreen = false;

  documentVersionsList = [];

  defaultColDef = { resizable: true,
                    sortable: true,
                    filter: true
                  };

  docReviewLoadingError = false;

  docReviewId = null;  // ID from the url

  currentDocReview = new DocumentReview();

  selectedViewMode = 'Hide Contract';
  contractViewModesWithoutText = [
    'Hide Contract',
    'Original'
  ];

  isOfficeDocument = false;
  safePdfHtml = null;
  officeSourceFile = null;
  trustedOfficeSource = null;
  missingContractFile = true;

  columnApi = null;
  gridApi = null;
  versionListGridApi = null;

  requestedReviewsList = [];

  allDocumentReviews = [];
  documentVersions = [];

  currentVersion = null;
  highestVersion = null;
  totalNumberOfVersions = null;

  columnDefs = [
                  importantDateColumns.colName,
                  importantDateColumns.colInternalRecipients,
                  importantDateColumns.colReminderDate,
                  importantDateColumns.colImportantDate
                ];


  // docVersionsColumnDefs = [
  //     {headerName: 'Name', field: 'object.name', width: 125 },
  //     {headerName: 'Version', field: 'Id', width: 100 }
  // ]

  docVersionsColumnDefs = [
      {headerName: 'Name', field: 'object.name', width: 125 },
      { headerName: 'Version',
        colId: 'version',
        field: 'Id',
        cellRenderer: this.versionFormatter,
        width: 100 }
  ]

  // export let colCriticalDate = {colId: 'criticalDates',
  // headerName: 'Critical Date',
  // field: 'assessmentData.criticalDate',
  // cellRenderer: dateFormatter,
  // width: 100 };

  existingActiveContract = false;


  constructor(
              
              public dialog: MatDialog,
              private _snackBar: MatSnackBar,
              public router: Router,
              private route: ActivatedRoute,
              public docReviewsService: DocumentReviewsService) { 


      super();
  }

  async ngOnInit() {

    window.scrollTo(0, 0);

    // this.globalDataService.toolbarTitle = 'Document Review Record';

    // this.route.paramMap.subscribe(params => {
    //       this.docReviewId = params.get('id');
    //     })

    // if (this.docReviewId) {
    //   this.initializeExistingDocReview(this.globalDataService.currentDocumentReview);
    // } else {
    //   console.log('DOC REVIEW FORM ERROR.  How did we get to a form without an ID?');
    //   this.docReviewLoadingError = true;
    // }

    // if (this.currentDocReview.entityUnderReviewObject) {

    //   console.log('editing existing doc review');
    //   this.existingActiveContract = true;
    //   this.initializeFormUsingContract(this.currentDocReview.entityUnderReviewObject);
    // }

    // this.selectedViewMode = 'Original';

    // this.allDocumentReviews = await this.docReviewsService.getAllDocReviews();
    // this.allDocumentReviews = this.allDocumentReviews['result']['Items'];

    // let self = this;

    // this.documentVersions = _.filter(this.allDocumentReviews,
    //     function(o) {
    //       return o.Id.includes(self.currentDocReview.Id);
    //   });

    // this.totalNumberOfVersions = this.documentVersions.length;

    // console.log('all document versions: ', this.documentVersions);

    // this.getHighestVersion();

  }



  switchFormToThisVersion(event) {

    //console.log('switch form to this version: ', event.data);

    // this.initializeExistingDocReview(event.data.object);
    // this.currentVersion = this.getVersionNumberFromId(event.data.Id);
  }



  getVersionNumberFromId(docReviewId) {

    // console.log('inside getVersionNumberFromId: ', docReviewId);

    let versionId = docReviewId.split('_');
    let versionString = versionId.toString().substring(1, 5); // remove first character 'v'
    let versionNum = parseInt(versionString);

    //console.log('returning version number: ', versionNum);

    return versionNum;
  }


  getHighestVersion() {

    let highestNumber = 1;
    let highestVersion = null;

    // this.documentVersions.forEach( doc => {

    //   let versionNum = this.getVersionNumberFromId(doc.Id);

    //   if (versionNum >= highestNumber) {
    //         highestNumber = versionNum;
    //         highestVersion = doc;
    //   }

    //   this.currentVersion = highestNumber;
    //   this.highestVersion = highestVersion;

    // })
  }





  async addEntityAsAttachment() {

    // let newAttachment = new Attachment();

    // newAttachment.contracts.push(this.currentDocReview.entityUnderReviewObject.contractNum);

  }





  async createNewContract() {

    // let result = await this.createNewContractFromExistingContract(this.currentDocReview.entityUnderReviewObject);

    // await this.delay(1000);

    // this.router.navigateByUrl('/securehome/new-contract');

  }





  // THIS IS REPLACE CONTRACT ONLY (need to add COI and BAA later)
  async replaceContract() {

    // TODO: replace contract implementation

    // this.router.navigateByUrl('/securehome/wait');

    // console.log('all doc review versions: ', this.documentVersions);

    // let foundActiveDocumentReview = this.documentVersions.find( docReview => docReview.status === 'active');

    // if (!foundActiveDocumentReview) {
    //   console.log('ERROR - NO CURRENT ACTIVE DOCUMENT REVIEW');
    // }

    // console.log('foundActiveDocumentReview: ', foundActiveDocumentReview);
    // console.log(this.currentDocReview);
    // console.log('entity: ', this.currentDocReview.entityUnderReviewObject);

    // let newContract = await this.replaceEntityContractTypeWithNewVersion(this.currentDocReview.entityUnderReviewObject);

    // console.log('new/replaced contract: ', newContract);

    // // Doc Review needs to be saved for this to work.
    // foundActiveDocumentReview.status = 'completed';
    // foundActiveDocumentReview.object = this.currentDocReview;
    // let response = await this.docReviewsService.updateExistingDocReview(foundActiveDocumentReview);

    // await this.delay(1000);

    // this.router.navigateByUrl('/securehome/new-contract');

  }




  replacedDocReviewVersionToast(): void {


    this._snackBar.openFromComponent(ToastMessageDialog, {
      duration: 5000,
    });

  }


  versionFormatter(params) {

    let idStringWithVersion = params.value;

    let versionAsArray = idStringWithVersion.split('_');
    let versionAsFriendlyFormat = versionAsArray[0];
    versionAsFriendlyFormat = versionAsFriendlyFormat.substr(1);

    while(versionAsFriendlyFormat.charAt(0) === '0')
    {
      versionAsFriendlyFormat = versionAsFriendlyFormat.substr(1);
    }

    return versionAsFriendlyFormat;
  }


  versionExtractor(idStringWithVersion) {

    let versionAsArray = idStringWithVersion.split('_');
    let versionAsFriendlyFormat = versionAsArray[0];
    versionAsFriendlyFormat = versionAsFriendlyFormat.substr(1);

    while(versionAsFriendlyFormat.charAt(0) === '0')
    {
      versionAsFriendlyFormat = versionAsFriendlyFormat.substr(1);
    }

    return versionAsFriendlyFormat;

  }


  newDocumentVersion() {

    this.replacedDocReviewVersionToast();

    this.docReviewsService.replaceDocReview(this.currentDocReview);
  }



  async initializeFormUsingContract(contractObject) {

    //console.log('processing entity in doc review: ', contractObject);

    // if (contractObject) {
    //   // this.currentDocReview.entityUnderReviewObject = contractObject;
    //   // this.currentDocReview.name = contractObject.nameOfContract;

    //   // if (contractObject.contractId == undefined) {
    //   //   this.currentDocReview.id = getUniqueId();
    //   // } else {
    //   //   this.currentDocReview.id = contractObject.contractId;
    //   // }


    //   if (contractObject.sites) {

    //     if (Array.isArray(contractObject.sites)) {

    //       contractObject.sites.forEach(element => {

    //         let foundSite = _.find(this.globalDataService.allSites, {'siteNum': element});

    //         if (foundSite != undefined) {
    //           this.siteFriendlyNames.push(foundSite.name);
    //         }

    //       });

    //     } else {

    //       let foundSite = _.find(this.globalDataService.allSites, {'siteNum': contractObject.sites});

    //       if (foundSite != undefined) {
    //         this.siteFriendlyNames.push(foundSite);
    //       }
    //     }
    //   }


    //   if (contractObject.directVendor != undefined) {
    //     console.log('doc review direct vendor: ', contractObject.directVendor);
    //     let foundParty = _.find(this.globalDataService.allParties, {'vendorNum': contractObject.directVendor});

    //     if (foundParty != undefined) {
    //       // console.log('party friendly name: ', foundParty);
    //       this.partyFriendlyName = foundParty.name;
    //     } else {
    //       this.partyFriendlyName = contractObject.directVendor.name;
    //     }
    //   }

    //   this.setLegalEntityFriendlyNames(contractObject);

    //   // if (contractObject.legalEntities != undefined) {

    //   //   if ((Array.isArray(contractObject.legalEntities)) &&
    //   //       (contractObject.legalEntities.length > 0)) {

    //   //         contractObject.legalEntities.forEach(element => {

    //   //           let foundLegalEntity = _.find(this.globalDataService.allLegalEntities, {'legalEntityNum': element});

    //   //           if (foundLegalEntity != undefined) {
    //   //             console.log('legal entity friendly name: ', foundLegalEntity);
    //   //             this.legalEntitiesFriendlyNames = this.legalEntitiesFriendlyNames.concat(foundLegalEntity.legalEntityName);
    //   //           }
    //   //         });
    //   //   } else {
    //   //     console.log('legal entities object: ', contractObject.legalEntities);
    //   //     this.legalEntitiesFriendlyNames = contractObject.legalEntities.legalEntityName;
    //   //   }
    //   // }
    // }

    // console.log('entityUnderReviewObject: ', this.currentDocReview.entityUnderReviewObject);

  }



  addNewInternalTaskRequest(): void {

    const dialogRef = this.dialog.open(NewCriticalDateComponent, {
      width: '800px',
      data: {
              entityNumber: this.currentDocReview.Id,
              entityType: 'docReview',
              entityName: this.currentDocReview.name,
              message: 'Document Review: ' + this.currentDocReview.name,
              title: 'Add Internal Task Request'
            }
    });

    dialogRef.afterClosed().subscribe(result => {
      //console.log('Closed Important Date dialog. From dialog =-> ', result);
      // this.currentDocReview.importantDates.push(result);
      // this.saveDocumentReview();
      // this.requestedReviewsList = this.requestedReviewsList
      //                                 .concat(this.globalDataService.currentImportantDate);
    });
  }


  async saveDocumentReview() {
    //console.log('current Document Review to save: ', this.currentDocReview);

    // Clean out the object so it will save.
    for (let key in this.currentDocReview.entityUnderReviewObject) {
      if (this.currentDocReview.entityUnderReviewObject[key] == '') {
        this.currentDocReview.entityUnderReviewObject[key] = null;
      }
    }

    let response = await this.docReviewsService.writeNewDocReview(this.currentDocReview);
    // this.router.navigateByUrl('/securehome/document-review-list');
  }


  initializeExistingDocReview(documentReview) {

    //console.log('inside initializeExistingDocReview: ', documentReview);

    // this.docReviewId = documentReview.Id;

    // console.log('initialize document review: ', this.docReviewId);

    // // this.currentDocReview = this.globalDataService.currentDocumentReview;
    // this.currentDocReview = documentReview;

    // console.log('current doc review: ', this.currentDocReview);

    // if ((this.currentDocReview) &&
    //     (this.currentDocReview.mainFileName != undefined)) {

    //       this.processContractFileAttachment();
    //       this.missingContractFile = false;
    // }

    // if ((this.currentDocReview.importantDates != undefined) &&
    //     (this.currentDocReview.importantDates.length > 0)) {

    //       this.globalDataService.getImportantDateObjectArray(this.currentDocReview.importantDates)
    //         .then(importantDatesObjectArray => {
    //           this.requestedReviewsList = this.requestedReviewsList.concat(importantDatesObjectArray);
    //           // this.criticalDatesObjectArray = _.uniq(this.criticalDatesObjectArray);
    //           console.log('requested reviews: ', this.requestedReviewsList);
    //         })
    // }

  }






  async tabChanged(event) {
    // console.log('tab changed event: ', event);
    //console.log('tab text label: ', event.tab.textLabel);
    this.tabSelected = event.tab.textLabel;

    // await this.delay(2000);

    switch (event.tab.textLabel) {
      case 'Reviews':
        this.reviewsTabOnScreen = true;
        break;
      case 'Document Versions':
        this.documentVersionsTabOnScreen = true;
        break;
      case 'Details':
        this.detailsTabOnScreen = true;
        break;
      default:
        this.reviewsTabOnScreen = false;
        this.documentVersionsTabOnScreen = false;
        this.detailsTabOnScreen = false;
    }

    // await this.delay(1000);

    // this.versionListGridApi.sizeColumnsToFit();
  }


  goToCurrentContract() {
    this.router.navigate(['/securehome/contract', this.currentDocReview.entityUnderReviewObject.contractNum]);
  }


  async editDocumentReview() {
    // TODO: editDocumentReview implementation

    // this.documentVersions = _.filter(this.allDocumentReviews,
    //   function(o) {
    //     return o.Id.includes(self.currentDocReview.id);
    // });

    // let largestVersionNum = 1;
    // let mostCurrentVersion = null;

    // this.documentVersions.forEach( doc => {

    //   console.log('doc Id: ', doc.Id);
    //   let currentDocVersion = this.versionExtractor(doc.Id);
    //   console.log('currentDocVersion: ', currentDocVersion);
    //   let docVersionAsInt = parseInt(currentDocVersion);

    //   if (docVersionAsInt >= largestVersionNum) {
    //     largestVersionNum = docVersionAsInt;
    //     mostCurrentVersion = doc;
    //   }

    // })

    // console.log('most current version: ', mostCurrentVersion);

    // this.globalDataService.editDocReview = true;
    // this.globalDataService.currentDocumentReview = _.cloneDeep(mostCurrentVersion);
    // await this.delay(1000);
    // console.log('globalDataService current doc review (inside view form): ', this.globalDataService.currentDocumentReview);
    // this.router.navigate(['/securehome/new-document-review']);
  }


  onGridReady(params) {
    this.gridApi = params.api;

    this.columnApi = params.columnApi;
  }


  onVersionListGridReady(params) {
    this.versionListGridApi = params.api;

  }


}
